<div class="search-results-mobile-toggle d-flex align-items-center b-grey" [class.map]="route == 'list'">
  <div class="py-2 px-4 filter-seperator d-flex align-items-center" (click)="swapView()"><i class="icon-{{ route }} mr-2"></i> {{ route | titlecase }}</div>

  <div class="py-2 px-3 pr-3 d-flex align-items-center" (click)="openFilterModal()">
    <span class="filter-count text-white bg-red mr-1" *ngIf="facetSelectedCount != 0">{{ facetSelectedCount }}</span>
    <i class="icon-filter mr-2" *ngIf="facetSelectedCount == 0"></i>
    <span>Filter</span>
  </div>
</div>
